import { Component, ElementRef, OnInit, ViewEncapsulation } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { debounceTime, filter } from 'rxjs/operators';

import { AppConfig } from '../app.config';
import { DynamicModalService, IComponentModel } from '../common/modals/dynamic-modal/dynamic-modal.service';

import { SidebarService } from './sidebar/sidebar.service';
declare var jQuery: any;
declare var Hammer: any;
declare var Raphael: any;

@Component({
  selector: 'shell',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './shell.template.html',
  host: {
    '[class.nav-static]': 'config.state["nav-static"]',
    '[class.chat-sidebar-opened]': 'chatOpened',
    '[class.app]': 'true',
    id: 'app'
  }
})
export class ShellComponent implements OnInit {
  config: any;
  configFn: any;
  $sidebar: any;
  el: ElementRef;
  router: Router;
  chatOpened = false;
  componentData: { component: any, inputs?: any } = null;

  constructor(config: AppConfig,
    el: ElementRef,
    router: Router,
    private dynamicModalService: DynamicModalService,
    private sidebarService: SidebarService) {
    Raphael.prototype.safari = (): any =>  {
      return;
    };
    this.el = el;
    this.config = config.getConfig();
    this.configFn = config;
    this.router = router;
  }

  ngOnInit(): void {
    this.dynamicModalService.componentData
      .subscribe((componentData: IComponentModel) => this.componentData = componentData);

    if (localStorage.getItem('nav-static') === 'true') {
      this.config.state['nav-static'] = true;
    }

    const $el = jQuery(this.el.nativeElement);
    this.$sidebar = $el.find('[sidebar]');

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      debounceTime(500))
      .subscribe(() => {
        if (jQuery('main').is('.fadeInUp')) {
          jQuery('main').removeClass('fadeInUp animated');
        }
      });

    this.$sidebar.on('mouseenter', () => this.sidebarMouseEnter());
    this.$sidebar.on('mouseleave', () => this.sidebarMouseLeave());

    this.checkNavigationState();

    this.$sidebar.on('click', () => {
      if (jQuery('shell').is('.nav-collapsed')) {
        this.expandNavigation();
      }
    });

    this.router.events.subscribe(() => {
      this.collapseNavIfSmallScreen();
      if (!this.router.url.startsWith('/overview')) return;
      window.scrollTo(0, 0);
    });

    if ('ontouchstart' in window) {
      this.enableSwipeCollapsing();
    }

    this.$sidebar.find('.collapse').on('show.bs.collapse', (e) => {
      if (e.target !== e.currentTarget) {
        return;
      }

      const $triggerLink = jQuery(this).prev('[data-toggle=collapse]');
      jQuery($triggerLink.data('parent'))
        .find('.collapse.in').not(jQuery(this)).collapse('hide');
    })
      .on('show.bs.collapse', function (e): void {
        if (e.target !== e.currentTarget) {
          return;
        }

        jQuery(this).closest('li').addClass('open');
      }).on('hide.bs.collapse', function (e): void {
        if (e.target !== e.currentTarget) {
          return;
        }

        jQuery(this).closest('li').removeClass('open');
      });
  }

  toggleSidebarListener(state): void {
    const toggleNavigation = state === 'static'
      ? this.toggleNavigationState
      : this.toggleNavigationCollapseState;
    toggleNavigation.apply(this);
    localStorage.setItem('nav-static', this.config.state['nav-static']);
    this.emitSidebarEvent();
  }

  toggleChatListener(): void {
    jQuery(this.el.nativeElement).find('.chat-notification-sing').remove();
    this.chatOpened = !this.chatOpened;

    setTimeout(() => {
      jQuery('.chat-sidebar-user-group:first-of-type ' +
        '.list-group-item:first-child:not(.js-notification-added)')
        .addClass('active js-notification-added')
        .find('.fa-circle')
        .after('<span class="badge tag-danger ' +
        'pull-right animated bounceInDown">3</span>');
    }, 1000);
  }

  toggleNavigationState(): void {
    this.config.state['nav-static'] = !this.config.state['nav-static'];
    if (!this.config.state['nav-static']) {
      this.collapseNavigation();
    }
  }

  expandNavigation(): void {
    if (this.isNavigationStatic()
      && (this.configFn.isScreen('lg') || this.configFn.isScreen('xl'))) {
      return;
    }

    jQuery('shell').removeClass('nav-collapsed');
    this.$sidebar.find('.active .active').closest('.collapse').collapse('show')
      .siblings('[data-toggle=collapse]').removeClass('collapsed');
  }

  collapseNavigation(): void {
    if (this.isNavigationStatic()
      && (this.configFn.isScreen('lg') || this.configFn.isScreen('xl'))) {
      return;
    }

    jQuery('shell').addClass('nav-collapsed');
    this.$sidebar.find('.collapse.in').collapse('hide')
      .siblings('[data-toggle=collapse]').addClass('collapsed');
  }

  checkNavigationState(): void {
    if (this.isNavigationStatic()) {
      if (this.configFn.isScreen('sm')
        || this.configFn.isScreen('xs') || this.configFn.isScreen('md')) {
        this.collapseNavigation();
      }
    } else {
      if (this.configFn.isScreen('lg') || this.configFn.isScreen('xl')) {
        setTimeout(() => {
          this.collapseNavigation();
          this.emitSidebarEvent();
        }, this.config.settings.navCollapseTimeout);
      } else {
        this.collapseNavigation();
      }
    }
  }

  isNavigationStatic(): boolean {
    return this.config.state['nav-static'] === true;
  }

  toggleNavigationCollapseState(): void {
    if (jQuery('shell').is('.nav-collapsed')) {
      this.expandNavigation();
    } else {
      this.collapseNavigation();
    }
  }

  enableSwipeCollapsing(): void {
    const swipe = new Hammer(document.getElementById('content-wrap'));
    const d = this;

    swipe.on('swipeleft', () => {
      setTimeout(() => {
        if (d.configFn.isScreen('md')) {
          return;
        }

        if (!jQuery('shell').is('.nav-collapsed')) {
          d.collapseNavigation();
        }
      });
    });

    swipe.on('swiperight', () => {
      if (d.configFn.isScreen('md') || jQuery('shell').is('.chat-sidebar-opened')) {
        return;
      }
      if (jQuery('shell').is('.nav-collapsed')) {
        d.expandNavigation();
      }
    });
  }

  collapseNavIfSmallScreen(): void {
    if (this.configFn.isScreen('xs')
      || this.configFn.isScreen('sm') || this.configFn.isScreen('md')) {
      this.collapseNavigation();
    }
  }

  private sidebarMouseEnter(): void {
    if (this.configFn.isScreen('lg') || this.configFn.isScreen('xl')) {
      this.expandNavigation();
      this.emitSidebarEvent();
    }
  }

  private sidebarMouseLeave(): void {
    if (this.configFn.isScreen('lg') || this.configFn.isScreen('xl')) {
      this.collapseNavigation();
      this.emitSidebarEvent();
    }
  }

  private emitSidebarEvent() {
    if (this.config.state['nav-static']) {
      return this.sidebarService.sidebarToggled();
    }
    this.sidebarService.sidebarAnimationStart();
  }
}
